export const IS_LITTLE_ENDIAN = false;
